// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__mE33g","right":"styles_right__1SE34"};